import React from "react";
import { usePlaylistOwnershipEdit, usePlaylistTracksEdit, usePlaylistTitleEdit, usePlaylistPublishStatusEdit, useUpdatePlaylist, usePlaylistBusinessTypesEdit, } from "frontend/src/domain/playlists";
import { useImageUpload } from "../../../lib/use-image-upload";
export var usePlaylistEdit = function (playlist) {
    var update = useUpdatePlaylist();
    var title = usePlaylistTitleEdit(playlist.title);
    var entries = usePlaylistTracksEdit(playlist.tracks);
    var ownership = usePlaylistOwnershipEdit({
        type: playlist.type,
        clientId: playlist.type === "private" ? playlist.client.id : null,
    });
    var published = usePlaylistPublishStatusEdit(playlist.isPublished);
    var businessTypes = usePlaylistBusinessTypesEdit(playlist.type === "public" ? playlist.businessTypes : []);
    var _a = useImageUpload({
        file: null,
        image: playlist.type === "public" ? playlist.imagePath : null,
    }), image = _a.image, onImageChange = _a.onImageChange, file = _a.file;
    var run = function () {
        if (title.validate() && ownership.validate()) {
            update.do({
                id: playlist.id,
                title: title.value,
                tracks: entries.tracks.map(function (track) { return track.id; }),
                published: published.value,
                client: ownership.clientId.value,
                businessTypesIds: businessTypes.value,
                image: file,
            });
        }
    };
    React.useEffect(function () {
        if (ownership.type.value === "private") {
            businessTypes.set([]);
        }
        else {
            businessTypes.setFromBusinessTypes(playlist.type === "public" ? playlist.businessTypes : []);
        }
    }, [ownership.type.value]);
    return {
        title: title,
        entries: entries,
        published: published,
        clientId: ownership.clientId,
        type: ownership.type,
        businessTypes: businessTypes,
        image: {
            value: image,
            onChange: onImageChange,
        },
        update: {
            run: run,
            pending: update.isLoading,
        },
    };
};
